export default "__VITE_ASSET__BiBJ3LBq__"